import React, { useEffect } from "react";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
function ViewPDF({ isOpen, toggleModal, titleName, images, currentImageIndex, fileType }) {
  const currentImage = images || "";
  return (
    <Modal isOpen={isOpen} toggle={toggleModal} size="xl">
      <ModalHeader toggle={toggleModal}>{titleName}</ModalHeader>
      <ModalBody >
        {currentImage && (
          <div style={{ textAlign: "center" }}>
            {/* <iframe
              className="img-thumbnail"
              src={images}
              style={{ height: "600px", width: "800px", objectFit: "cover" }}
              title="PDF Preview"
            /> */}
            <iframe
              style={{ height: "600px", width: "800px", objectFit: "cover" }}
              src={images}
              title={titleName}
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerpolicy="strict-origin-when-cross-origin"
              allowfullscreen
            ></iframe>
          </div>
        )}
      </ModalBody>
    </Modal>
  );
}

export default ViewPDF;
